"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _headerUtils = require("./headerUtils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Header = props => {
  const {
    headerInfo,
    t,
    soldOut = false,
    ticketsSoon = false
  } = props;
  const [navVisible, setNavVisible] = (0, _react.useState)(false);
  const toggleNavigation = () => {
    setNavVisible(!navVisible);
  };
  const minWindowWidth = 1060;
  (0, _react.useEffect)(() => {
    const handleResize = () => {
      const currentWindowWidth = window.innerWidth;
      if (currentWindowWidth > minWindowWidth) {
        setNavVisible(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [minWindowWidth]);
  const toggleMobileNav = () => {
    if (window.innerWidth <= minWindowWidth) {
      setNavVisible(prev => !prev);
    }
  };
  return /*#__PURE__*/_react.default.createElement("header", {
    className: "con-header zoomout-limited"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-header__inner"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-heading__main"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: "con-home-link",
    to: "/"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "con-visually-hidden"
  }, "".concat(headerInfo.logoAltText, " link to homepage")), /*#__PURE__*/_react.default.createElement("img", {
    className: "con-header__logo",
    src: headerInfo.logoUrl,
    alt: headerInfo.logoAltText
  }))), /*#__PURE__*/_react.default.createElement("button", {
    className: "con-header__burger-icon ".concat(navVisible ? "con-header__burger-icon--visible" : "con-header__burger-icon--hidden"),
    style: {
      "--menu-icon": "url(".concat(t("Navigation.MenuIconUrl"), ")"),
      "--menu-open-icon": "url(".concat(t("Navigation.MenuIconOpenUrl"), ")")
    },
    title: "toggle",
    onClick: () => {
      toggleNavigation();
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "con-header__navigation".concat(navVisible ? "--visible" : "--hidden")
  }, /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", {
    className: "con-header__navigation--items-links"
  }, headerInfo.headerList.map((item, id) => {
    return item.headerType.toLowerCase() === "link" && /*#__PURE__*/_react.default.createElement(_headerUtils.HeaderLink, {
      t: t,
      item: item,
      toggleMobileNav: toggleMobileNav,
      navVisible: navVisible,
      key: id
    });
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "con-header__navigation--items".concat(navVisible ? "-links" : "-buttons")
  }, headerInfo.headerList.map((item, id) => {
    return item.headerType.toLowerCase() === "button" && /*#__PURE__*/_react.default.createElement(_headerUtils.HeaderLink, {
      t: t,
      item: item,
      toggleMobileNav: toggleMobileNav,
      navVisible: navVisible,
      soldOut: soldOut,
      ticketsSoon: ticketsSoon,
      key: id
    });
  })))));
};
exports.Header = Header;
Header.propTypes = {
  headerInfo: _propTypes.default.shape({
    logoUrl: _propTypes.default.string,
    logoAltText: _propTypes.default.string,
    headerList: _propTypes.default.arrayOf(_propTypes.default.shape({
      headerType: _propTypes.default.string,
      headerElement: _propTypes.default.object
    }))
  }),
  t: _propTypes.default.func,
  soldOut: _propTypes.default.bool,
  ticketsSoon: _propTypes.default.bool
};